export default __webpack_public_path__ + "static/media/alliances-2.ce68e81a.jpg";